import * as React from "react";
var ColumnIcon = function ColumnIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("title", null, "insert-column"), /*#__PURE__*/React.createElement("path", {
    d: "m19.4 14.3 12 6.7-4.5 1.3 2.2 4.7c.5.8.2 1.9-.5 2.5-.8.5-1.8.5-2.5-.2L22 25l-3.5 3.2.9-13.9zM14.5 23c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-13c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h13zm2-10c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-15c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h15zm13-10c.3 0 .5.2.5.5v4c0 .3-.2.5-.5.5h-28c-.3 0-.5-.2-.5-.5v-4c0-.3.2-.5.5-.5h28z",
    style: {
      fill: props.color
    }
  }));
};
export default ColumnIcon;